import RequireModule from 'routes/components/RequireModule';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import Allowed from 'components/shared/Permissions/Allowed';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const IncomeIQueue = withLazyFallback(
  () => import('components/practice/BeyondBilling/IncomeIQueue/IncomeIQueue')
);
const IncomeIQueueTable = withLazyFallback(
  () => import('components/practice/BeyondBilling/IncomeIQueue/components/IncomeIQueueTable')
);
const EligibilityChecks = withLazyFallback(
  () =>
    import('components/practice/BeyondBilling/IncomeIQueue/components/EligibilityChecks/EligibilityChecks')
);
const PayerRules = withLazyFallback(
  () => import('components/practice/BeyondBilling/IncomeIQueue/components/PayerRules/PayerRules')
);

const PRACTICE_BEYOND_BILLING_INCOME_I_QUEUE = {
  path: 'income-i-queue',
  element: (
    <RequireModule module="medipay.payment_suite">
      <IncomeIQueue />
    </RequireModule>
  ),
  handle: { title: 'IncomeIQueue' },
  children: [
    { path: '', element: <IncomeIQueueTable />, handle: { title: 'Queues' } },
    {
      path: 'payer-rules',
      element: <PayerRules />,
      handle: { title: 'Payer rules & SOF updates' }
    },
    {
      path: 'eligibility-checks',
      element: (
        <RequireModule module="medipay.eligibility_suite">
          <Allowed requiredPermissions="billing.eligibility_read" showIllustration showMessage>
            <EligibilityChecks />
          </Allowed>
        </RequireModule>
      ),
      handle: { title: 'Eligibility checks' }
    },
    { path: '*', element: <NotFound /> }
  ]
};

export default PRACTICE_BEYOND_BILLING_INCOME_I_QUEUE;
